import React from 'react';
import { SoundEffectsContext } from './context';
import { useSoundEffectsProvider } from './use-sound-effects-provider';

export const SoundEffectsProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useSoundEffectsProvider();
  return <SoundEffectsContext.Provider value={value}>{children}</SoundEffectsContext.Provider>;
};
export default SoundEffectsProvider;
